import React, { FunctionComponent as FC, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { State } from '../../../../../state';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../../../../state';
import './index.scss';
import _ from 'lodash';
import { MainViewTypes } from '../../../../../types/data';
import { impactEntityList, cpcCode2Name, CitationFlowType, ImpactType } from '../../../../../types/data.global';


interface OptimizedBubbleTreemapProps {
  entityFieldGraphData: any;
  predictionDataDict: MainViewTypes.PredictionResultDict;
}

const OptimizedBubbleTreemap: FC<OptimizedBubbleTreemapProps> = (props) => {

  const { entityFieldGraphData, predictionDataDict } = props


  // console.log('\n\n\n=============== component OptimizedBubbleTreemap(): start ===============')


  // Redux
  const dispatch = useDispatch();
  const {
    updateLeafNodePositionList,
    updateIsOptimizedBubbleTreemapFinished,
    updateIsEntityFieldGraphFinished,
    updateEntityFieldGraph_InputData,
    updateLeafNodeSizeScale,
    updateLeafNodeSizeScaleForHighlightedGrantField,

    // wordle
    isShowWordle,
    updateWordlePosition,
    updateWordleEntity,

    // interaction
    updateSelectedImpactEntityField,
    isShowPredictionFlow,
    isShowHistoricalFlow,
    updatePredictionSearchResult,
    updatePredictionGrantIDList4PIView,
    onClickGrantFieldNode,
    onClickImpactFieldNode,
    updateHighlghtedGrantFieldID,

    setShowEntityFieldLevelGraph,
    setShowEntityTypeLevelGraph
  } = bindActionCreators(actionCreators, dispatch);


  // ui reducer
  const highlghtedGrantFieldNode: MainViewTypes.HighlightedGrantFieldNode = useSelector((state: State) => state.dataReducer?.highlghtedGrantFieldNode) as MainViewTypes.HighlightedGrantFieldNode
  const highlightedImpactFieldNode: MainViewTypes.HighlightedImpactFieldNode = useSelector((state: State) => state.dataReducer?.highlightedImpactFieldNode) as MainViewTypes.HighlightedImpactFieldNode
  const isShowPredictionGraph = useSelector((state: State) => state.uiReducer?.isShowPredictionGraph) as boolean;
  const isShowHistoricalGraph = useSelector((state: State) => state.uiReducer?.isShowHistoricalGraph) as boolean;
  const isInitializeBubbleTreemapFinished = useSelector((state: State) => state.uiReducer?.isInitializeBubbleTreemapFinished) as boolean;
  const isEntityTypeGraphFinished = useSelector((state: State) => state.dataReducer?.isEntityTypeGraphFinished) as boolean;
  const isOptimizingMainViewLayoutFinished = useSelector((state: State) => state.dataReducer?.isOptimizingMainViewLayoutFinished) as boolean;

  // data reducer
  const leafNodeSizeScale = useSelector((state: State) => state.dataReducer?.leafNodeSizeScale) as number;
  const leafNodeSizeScaleType = useSelector((state: State) => state.dataReducer?.leafNodeSizeScaleType) as string;
  const bubbleTreemapCircumscribedRadiiDict = useSelector((state: State) => state.dataReducer?.bubbleTreemapCircumscribedRadiiDict) as {[key: string]: number};

  // new version:
  const impactType: string = useSelector((state: State) => state.uiReducer?.impactType) as string
  const citationFlowType: string = useSelector((state: State) => state.uiReducer?.citationFlowType) as string
  const isShowLeafNode: boolean = useSelector((state: State) => state.uiReducer?.isShowLeafNode) as boolean
  const bubbleTreemapGeometryGroup = useSelector((state: State) => state.dataReducer?.bubbleTreemapGeometryGroup) as MainViewTypes.BubbleTreemapGeometryGroup[];
  const parts = impactType.split("_")
  const impactTypeRefined = parts.slice(0, 2).join("_")

  // old version:
  const bubbleTreemapEntityGroupList = useSelector((state: State) => state.dataReducer?.bubbleTreemapEntityGroupList) as MainViewTypes.BubbleTreemapEntityTypeGroup[];
  const entityTypeLayoutData = useSelector((state: State) => state.dataReducer?.entityTypeLayoutData) as any
  const mainviewLayoutOptimizationParams = useSelector((state: State) => state.dataReducer?.mainviewLayoutOptimizationParams) as MainViewTypes.MainViewLayoutOptimizationParams | undefined;
  const leafNodePosition_InitialCenter = useSelector((state: State) => state.dataReducer?.leafNodePosition_InitialCenter) as {
    leafNodePositionList: MainViewTypes.LeafNodePosition[];
    bubbleTreemapEntityTypeCenterXYList: MainViewTypes.BubbleTreemapCenterPositionWarpper[];
  };

  // 拆出可空参数，避免在 Hook 前早退
  const Scale = mainviewLayoutOptimizationParams?.Scale ?? 1;
  const EdgeLengthScale = mainviewLayoutOptimizationParams?.EdgeLengthScale;

  // update node size scale
  const updatedLeafNodeSizeScale = leafNodeSizeScale * Scale

  // console.log('--------------------------------')
  // console.log('---- calc leafNodeSizeScale ----')
  // console.log('--------------------------------')
  // console.log('leafNodeSizeScale: ', leafNodeSizeScale)
  // console.log('Scale: ', Scale)
  // console.log('updatedLeafNodeSizeScale: ', updatedLeafNodeSizeScale)


  console.log('========> isShowLeafNode: ', isShowLeafNode)
  // console.log('========> highlightedImpactFieldNode: ', highlightedImpactFieldNode)


  // // debug
  // console.log('mainviewLayoutOptimizationParams: ', mainviewLayoutOptimizationParams)
  // console.log('entityTypeLayoutData: ', entityTypeLayoutData)
  // console.log('leafNodePosition_InitialCenter: ', leafNodePosition_InitialCenter)
  // console.log('citationFlowType from UI reducer: ', citationFlowType)


  // ============== 计算区：只做纯计算，不 dispatch（顺序固定） ==============

  // 1) 基于 entityTypeLayoutData 计算“更新后的 impact centers”
  const { grantNode, updatedImpactTypeBubbleTreemapCenterList } = useMemo(() => {
    const nodes = entityTypeLayoutData?.nodes || [];
    const grant = nodes.find((n: any) => n.group === 'grant') || null;
    const impacts = nodes.filter((n: any) => n.group !== 'grant');

    const updatedCenters =
      grant && EdgeLengthScale != null
        ? impacts.map((node: any) => ({
            x: grant.x + EdgeLengthScale * (node.x - grant.x),
            y: grant.y + EdgeLengthScale * (node.y - grant.y),
            group: node.group,
            id: node.id,
          }))
        : [];
    return { grantNode: grant, updatedImpactTypeBubbleTreemapCenterList: updatedCenters };
  }, [entityTypeLayoutData?.nodes, EdgeLengthScale]);

  // 2) 生成优化后的每个实体组的 JSX（先绕原中心 scale，再整体平移到新中心）

  // ==== copy from InitializeBubbleTreemap() ====
  let mainviewData: any = {}
  let entityFieldGraph_InputData: any[] = []
  if (!_.isEmpty(entityFieldGraphData)) {
    // 1. only for impactType === 'indirect_impact_folded': create a new object without the 'paper' key
    if (impactType === ImpactType.INDIRECT_IMPACT_FOLDED) {
      let node_IndirectImpact_folded = _.omit(entityFieldGraphData[impactTypeRefined].node, 'paper')
      mainviewData = {
        'node': node_IndirectImpact_folded,
        'link': entityFieldGraphData[impactTypeRefined].link.folded,
        'grant_field_level_data': entityFieldGraphData[impactTypeRefined].grant_field_level_data
      }
    } else if (impactType === ImpactType.DIRECT_IMPACT) {
      mainviewData = entityFieldGraphData[impactType]
    } else if (impactType === ImpactType.INDIRECT_IMPACT_UNFOLDED) {
      mainviewData = {
        'node': entityFieldGraphData[impactTypeRefined].node,
        'link': entityFieldGraphData[impactTypeRefined].link.unfolded,
        'grant_field_level_data': entityFieldGraphData[impactTypeRefined].grant_field_level_data, // temp: currently return folded link, TODO: add unfolded link
      }
    }
    // console.log('mainviewData: ', mainviewData)

    // 2-2 get `entityFieldGraph_InputData`
    _.forEach(mainviewData.node, (entityData: any, entity: string) => {
      const hierarchicalData = _.cloneDeep(entityData['hierarchical_entity_field_data'])
      // Check if hierarchicalData is not null before trying to set properties
      if (hierarchicalData) {
        // update radius
        // temp: hard code
        // TODO: 现在radius of entity_type node是fixed constant (R=100)。需要根据画布大小等动态更新
        // const R = 200
        // hierarchicalData['radius'] = R
        entityFieldGraph_InputData.push(hierarchicalData)
      }
    })
  }
  const predictionData = predictionDataDict.grant_id_list_subinstitution  // to show prediction result
  const predictionDataGlobal = predictionDataDict.grant_id_list_all_institute
  const updatedEntityFieldData = entityFieldGraph_InputData

  // const [highlightedNode, setHighlightedNode] = useState<MainViewTypes.HighlightedImpactFieldNodeCorrespondingGrantFieldNode>({
  //   grantFieldID: highlghtedGrantFieldNode.grantFieldID,
  //   grantFieldName: highlghtedGrantFieldNode.grantFieldName,
  // })
  // const [highlightedNode, setHighlightedNode] = useState<MainViewTypes.HighlightedImpactFieldNodeCorrespondingGrantFieldNode>({
  //   grantFieldID: '',
  //   grantFieldName: '',
  // })

  // console.log('highlightedNode: ', highlightedNode)
  console.log('highlghtedGrantFieldNode: ', highlghtedGrantFieldNode)

  const handleMouseRightClick = (e: MouseEvent, id: string) => {
    const parts = id.split("=");
    const impactEntity: string = parts[2];
    console.log('impactEntity: ', impactEntity)

    // // show context menu
    // isShowContextMenu(true)
    // updateContextMenuImpactEntity(impactEntity)
    // updateContextMenuPosition({
    //   left: e.clientX + 8,
    //   top: e.clientY + 8,
    // })
  }
  const handleMouseLeave = (e: MouseEvent, id: string) => {
    const parts = id.split("=");
    const fieldID: string = parts[2];
    const impactEntity: string = parts[3];

    // hide wordle
    isShowWordle(false)
  }
  const handleMouseEnter = (e: MouseEvent, id: string) => {
    const parts = id.split("=");
    const fieldID: string = parts[2];
    const impactEntity: string = parts[3];

    // console.log('hover: ', id)
    // console.log('\n\n\nhandleMouseEnter: ', fieldID, impactEntity)

    // show wordle
    isShowWordle(true)
    updateWordlePosition({
      left: e.clientX + 24,
      top: e.clientY + 24,
    })
    updateWordleEntity({
      // impact type (direct/indirect): 用state变量impactType即可
      entity: impactEntity,
      fieldID: fieldID,
    })
  }
  const handleMouseOnClick = (e: MouseEvent, id: string) => {
    // const parts = id.split("-");
    const parts = id.split("=");
    const fieldID: string = parts[2];
    const impactEntity: string = parts[3];

    // leaf-node-A61K-patent
    // leaf-node-D27.505.696.577-clinical_trial
    // leaf-node-r={21.220423272433884}-value={206}-C10.574.945.249-clinical_trial

    // 根据impact type，决定
    // 1. historical的时候，只更新右下角
    // 2. prediction的时候，只更新PI view信息

    console.log('\n\n\n========== handleMouseOnClick (start) ==========')
    console.log('citationFlowType: ', citationFlowType)
    console.log('impactTypeRefined: ', impactTypeRefined)
    console.log('impactEntity: ', impactEntity) // impact type: paper, patent, clinical_trial, policy, newsfeed
    console.log('fieldID: ', fieldID) // impact field ID
    console.log('========== handleMouseOnClick (end) ==========\n\n\n')


    if (citationFlowType === CitationFlowType.HISTORICAL) {
      // (1) if historical flow, 接xiaoyu右下角barchart更新
      updateSelectedImpactEntityField({
        [impactEntity]: fieldID,
      })

      // (2) update highlighted impact field node
      if (fieldID === highlightedImpactFieldNode.impactFieldID) {
        // clear up highlighted impact field node
        onClickImpactFieldNode({
          impactType: impactType,  // direct/indirect
          impactEntity: '', // paper, patent, clinical_trial, policy, newsfeed
          impactFieldID: '', // C11.768, C23.888, etc.
        })
      } else {
        onClickImpactFieldNode({
          impactType: impactType,  // direct/indirect
          impactEntity: impactEntity, // paper, patent, clinical_trial, policy, newsfeed
          impactFieldID: fieldID, // C11.768, C23.888, etc.
        })
      }

      // and clear up historical selected grant_field node
      updateHighlghtedGrantFieldID('')
      onClickGrantFieldNode({
        grantFieldID: '',
        grantFieldName: '',
        impactType: impactType,
      })

      // (3) show historical flow from this impact field node to all grant_field nodes
      isShowPredictionFlow(false)
      isShowHistoricalFlow(true)
    } else if (citationFlowType === CitationFlowType.PREDICTION) {
      // (2) if prediction flow, 高亮prediction result: grantNode + flow高亮 + PI view更新
      const predictionSearchResult: MainViewTypes.PredictionSearchResult = {
        entity: impactEntity, // 'clinical_trial',
        fieldIDList: [fieldID], // ['C11.768', 'C23.888'],
      }
      updatePredictionSearchResult(predictionSearchResult)
      // isShowPredictionFlow(true) // 从impact entity field出发画flow
      // isShowHistoricalFlow(false) // 从grant_field出发画flow。本质flow是一样的，只是highlight的flow不一样

      // update PI view
      let predictedData: MainViewTypes.PredictionEntityFieldIDUnit | undefined;
      let predictedDataGlobal: MainViewTypes.PredictionEntityFieldIDUnit | undefined;
      if (predictionData[impactTypeRefined] && predictionData[impactTypeRefined][impactEntity]) {
        predictedData = predictionData[impactTypeRefined][impactEntity].find((fieldIDData: MainViewTypes.PredictionEntityFieldIDUnit) => fieldIDData.field_id === fieldID)
        predictedDataGlobal = predictionDataGlobal[impactTypeRefined][impactEntity].find((fieldIDData: MainViewTypes.PredictionEntityFieldIDUnit) => fieldIDData.field_id === fieldID)
      } else {
        console.log('==> OptimizedBubbleTreemap() > predictionData[impactTypeRefined][impactEntity] is not found')
      }
      // console.log('==> OptimizedBubbleTreemap() > predictedData: ', predictedData)
      // console.log('==> OptimizedBubbleTreemap() > predictedDataGlobal: ', predictedDataGlobal)
      if (predictedData && predictedDataGlobal) {
        updatePredictionGrantIDList4PIView(predictedData.grant_id_list, predictedDataGlobal.grant_id_list)
      } else {
        console.log('==> OptimizedBubbleTreemap() > predictedData or predictedDataGlobal is not found')
      }
      // 以及点击一个impact field node以后，右下角更新chart的接口是state的哪里？


      // (2) update highlighted impact field node
      if (fieldID === highlightedImpactFieldNode.impactFieldID) {
        // clear up highlighted impact field node
        onClickImpactFieldNode({
          impactType: impactType,  // direct/indirect
          impactEntity: '', // paper, patent, clinical_trial, policy, newsfeed
          impactFieldID: '', // C11.768, C23.888, etc.
        })
      } else {
        onClickImpactFieldNode({
          impactType: impactType,  // direct/indirect
          impactEntity: impactEntity, // paper, patent, clinical_trial, policy, newsfeed
          impactFieldID: fieldID, // C11.768, C23.888, etc.
        })
      }

      // clear up historical selected (1) citation flow (2) highlight node
      onClickGrantFieldNode({
        grantFieldID: '',
        grantFieldName: '',
        impactType: impactType,
        // impactType: ImpactType.DIRECT_IMPACT,
      })

      // change node color in this component
      // debug
      // console.log('==> InitializeBubbleTreemap() > highlightedNode: ', {
      //   grantFieldID: fieldID,
      //   grantFieldName: impactEntity,
      // })
      // setHighlightedNode({
      //   grantFieldID: fieldID,
      //   grantFieldName: impactEntity,
      // })
    }
  }
  // ==== copy from InitializeBubbleTreemap() ====


  // console.log('========> isShowPredictionGraph: ', isShowPredictionGraph)
  // console.log('========> isShowHistoricalGraph: ', isShowHistoricalGraph)


  // new version
  const optimizedBubbleTreemapEntityTypeGroupElementList = useMemo(() => {
    const list = bubbleTreemapGeometryGroup.map((entityGroup: MainViewTypes.BubbleTreemapGeometryGroup) => {
      const { entityType, center, impactType, contourList_ImpactType_Data, leafNodeList_ImpactType_Data } = entityGroup;

      const originalJSXElementList: JSX.Element[] = []
      // === copy same code from drawBubbleTreemap(): start ===
      // find entity type force-directed graph node position
      const entityTypeGraph_NodePosition = updatedEntityFieldData.find(entity => entity.name === impactType)
      // generate JSX Element
      if ((leafNodeList_ImpactType_Data.length > 0) && (contourList_ImpactType_Data.length > 0) && (entityTypeGraph_NodePosition)){
        // (1) draw leaf node
        const leafNodeElementList: JSX.Element[] = leafNodeList_ImpactType_Data.map((node: any, idx: number) => {
          // set text label
          let textInfo: string = node.data.name
          if (impactType === 'newsfeed' || impactType === 'policy') {
            // pass
          } else if (impactType === 'patent') {
            // textInfo = cpcCode2Name[node.data.name]
          } else if (impactType === 'clinical_trial') {
            // textInfo = meshCode2Name[node.data.name]
          } else if (impactType === 'paper') {
            // pass
          } else {
            console.log('error: unknown impact type')
          }

          // set fill color
          let fill = "none"
          let fillText = "white"
          let opacityText = 1
          let opacity = 1
          let leafNodeBorder = "none"
          if (isShowLeafNode === false) {
            opacity = 0
            // if (highlghtedGrantFieldNode.grantFieldID === '') {
            //   opacity = 1
            // }
          }

          // console.log('highlightedNode: ', highlightedNode)
          // console.log('highlightedImpactFieldNode: ', highlightedImpactFieldNode)
          // console.log('isShowPredictionGraph: ', isShowPredictionGraph)
          // console.log('isShowHistoricalGraph: ', isShowHistoricalGraph)

          if (isShowPredictionGraph) {
            if (highlightedImpactFieldNode.impactFieldID === node.data.name && highlightedImpactFieldNode.impactEntity === impactType) {
              // console.log('condition (1)')
              fill = 'url(#leaf-node-fill-predict)'
            } else if (highlightedImpactFieldNode.impactFieldID === '' && highlightedImpactFieldNode.impactEntity === '') {
              // console.log('condition (2)')
              fill = 'url(#leaf-node-fill-predict)'
            } else {
              // console.log('condition (3)')
              // fill = 'url(#leaf-node-fill-predict)'
              fill = 'none'
              // fillText = "none"
              opacityText = 0.8
              opacity = 0
              leafNodeBorder = "rgb(255, 255, 255)"
            }
          } else if (isShowHistoricalGraph) {
            if (highlghtedGrantFieldNode.grantFieldID !== '') {
              // console.log('condition (4)')
              fill = 'none'
            } else if (highlightedImpactFieldNode.impactFieldID !== '') {
              if (highlightedImpactFieldNode.impactFieldID === node.data.name && highlightedImpactFieldNode.impactEntity === impactType) {
                // console.log('condition (5)')
                fill = 'url(#leaf-node-fill)'
                opacity = 1
              } else {
                // console.log('condition (6)')
                // fill = 'url(#leaf-node-fill)'
                fill = 'none'
                // fillText = "none"
                opacityText = 0.8
                opacity = 1
                leafNodeBorder = "rgb(255, 255, 255)"
              }
              // fill = 'url(#leaf-node-fill)'
            } else if ((highlghtedGrantFieldNode.grantFieldID === '' && highlghtedGrantFieldNode.grantFieldName === '') || (highlightedImpactFieldNode.impactFieldID === '' && highlightedImpactFieldNode.impactEntity === '')) {
              console.log('condition (7)')
              fill = "url(#leaf-node-fill)"
              // opacity = 0.2
            } else {
              // console.log('condition (8)')
              // fill = "url(#leaf-node-fill)"
              fill = 'none'
              // fillText = "none"
              opacityText = 0.8
              opacity = 0.2
              leafNodeBorder = "rgb(255, 255, 255)"
            }
            // fill = "url(#leaf-node-fill)"
          } else {
            // console.log('condition (9)')
            fill = 'none'
          }
          // if (highlightedNode.grantFieldID === node.data.name && highlightedNode.grantFieldName === impactType) {
          //   fill = 'url(#leaf-node-fill-predict)'
          // } else if (highlightedNode.grantFieldID === '' && highlightedNode.grantFieldName === '') {
          //   fill = "url(#leaf-node-fill)"
          // } else {
          //   fill = 'none'
          // }


          // console.log('fill: ', fill)
          // console.log('fillText: ', fillText)
          // console.log('opacityText: ', opacityText)
          // console.log('opacity: ', opacity)
          // console.log('leafNodeBorder: ', leafNodeBorder)



          return (
            <g key={`leaf-node-${node.data.name}-${impactType}`}
               id={`leaf=node=${node.data.name}=${impactType}`}
            // <g key={`leaf-node-${node.data.name}-${impactType}`} id={`leaf-node-${node.data.name}-${impactType}`}
                style={{ cursor: 'pointer' }}
                onMouseEnter={(e) => {
                  const id = e.currentTarget.id
                  // console.log('hover: ', id)
                  handleMouseEnter(e as unknown as MouseEvent, id)
                }}
                onMouseLeave={(e) => {
                  // console.log('leave!!!!!')
                  const id = e.currentTarget.id
                  handleMouseLeave(e as unknown as MouseEvent, id)
                }}
                onClick={(e) => {
                  // console.log('down!!!!!')
                  const id = e.currentTarget.id
                  handleMouseOnClick(e as unknown as MouseEvent, id)
                }}
            >
              <circle id={`leaf-node-r={${node.r}}-value={${node.data.value}}-${node.data.name}-${impactType}`}
                cx={node.x} cy={node.y} r={Math.pow(node.r, 1)} // r={node.r}
                // fill="#6F999B"
                // fill={node.depth === 0 ? "red" : node.children ? "grey" : "steelblue"}
                // fill="url(#leaf-node-fill)"
                fill={fill}
                opacity={ opacity }
                stroke={leafNodeBorder}
                strokeWidth={3}
                strokeDasharray={"5 8"}
                // opacity={ (isShowLeafNode) ? 1 : 0}
                // stroke="transparent" strokeWidth={4}
              />
              <text
                id={`leaf-node-text-label-${node.data.name}-${impactType}`}
                x={node.x}
                y={node.y}
                dy=".35em"
                textAnchor="middle"
                fill={fillText} // "white"
                opacity={ opacityText }
                fontSize={14}
                style={{
                  filter: 'drop-shadow(2px 2px 4px rgba(120, 120, 120, 0.3))',
                  textShadow: '2px 2px 4px rgba(88, 88, 88, 0.43)'
                }}
              >
                {textInfo}
              </text>
            </g>
          )
        })
        // (2) draw contour
        let fill = "none"
        if (isShowPredictionGraph) {
          fill = 'url(#counter-node-fill-predict)'
        } else if (isShowHistoricalGraph) {
          fill = "url(#counter-node-fill)"
        } else if (highlghtedGrantFieldNode.grantFieldID === '' && highlghtedGrantFieldNode.grantFieldName === '') {
          fill = "url(#counter-node-fill)"
        } else {
          fill = 'none'
        }
        // let fill = "url(#counter-node-fill)"
        // if (highlightedNode.grantFieldName === impactType) {
        //   fill = 'url(#counter-node-fill-predict)'
        // } else if (highlightedNode.grantFieldID === '' && highlightedNode.grantFieldName === '') {
        //   fill = "url(#counter-node-fill)"
        // } else {
        //   fill = 'none'
        // }
        const contourElementList: JSX.Element[] = contourList_ImpactType_Data.map((arc, idx) => (
          <path key={`${idx}`} id={`${idx}`} d={arc.d} transform={arc.transform}
                // filter="url(#frosted-glass-effect)"
                fill={fill}
                // fill="url(#counter-node-fill)"
                fillOpacity={0.5}
                stroke="white" strokeWidth={1}  strokeOpacity={1}
                // fill="#6F999B"
                // fillRule="evenodd"
          />
        ))

        // (3) draw current impact type bubble treemap group
        // set position transformation for each impact type node's text label
        const centerX: number = _.meanBy(leafNodeList_ImpactType_Data, 'x')
        const centerY: number = _.meanBy(leafNodeList_ImpactType_Data, 'y')

        // update JSX Element
        originalJSXElementList.push(<g
          // ref={(el) => groupRefs.current && (groupRefs.current[impactType] = el)}
          key={impactType}
          id={`bubble-treemap-${impactType}-g`}
          // transform={`translate(${-centerX + entityTypeGraph_NodePosition.x}, ${-centerY + entityTypeGraph_NodePosition.y})`}
          // // transform={`translate(${-centerX + entityTypeGraph_NodePosition.x}, ${-centerY + entityTypeGraph_NodePosition.y}) rotate(${rotate}, ${centerX}, ${centerY})`}

          onContextMenu={(e) => {
            // console.log('right click the context menu: ')
            e.preventDefault()
            const id = e.currentTarget.id
            handleMouseRightClick(e as unknown as MouseEvent, id)
          }}
        >
          {contourElementList}
          {leafNodeElementList}
          <text id={`bubble-treemap-text-label-${impactType}`} transform={`translate(${centerX}, ${centerY})`} fontSize={14} fill="#404040">{impactType}</text>
        </g>)
      } else {
        originalJSXElementList.push(<g key={impactType} id={impactType}></g>  // empty element group
        )
      }
      // === copy same code from drawBubbleTreemap(): end ===






      // add new: transformation from optimization algorithm
      const originalCenterX = center.x;
      const originalCenterY = center.y;

      const updated = updatedImpactTypeBubbleTreemapCenterList.find((c: any) => c.group === entityType);
      const updatedCenterX = updated?.x ?? originalCenterX;
      const updatedCenterY = updated?.y ?? originalCenterY;

      // 注意：transform 从右到左应用
      return (
        <g
          id={`optimized-bubble-treemap-entity-group-${entityType}`}
          key={`optimized-group-${entityType}`}
          transform={`translate(${updatedCenterX - originalCenterX}, ${updatedCenterY - originalCenterY})`}
        >
          <g
            transform={`
              translate(${originalCenterX}, ${originalCenterY})
              scale(${Scale ?? 1})
              translate(${-originalCenterX}, ${-originalCenterY})
            `}
          >
            {originalJSXElementList}
          </g>
        </g>
      );
    });
    return list;
  }, [
    bubbleTreemapGeometryGroup, updatedImpactTypeBubbleTreemapCenterList,
    Scale, citationFlowType,
    highlghtedGrantFieldNode, highlightedImpactFieldNode, isShowPredictionGraph, isShowHistoricalGraph
  ]);

  // old version (to delete)
  const optimizedBubbleTreemapEntityTypeGroupElementList_old = useMemo(() => {
    const list = bubbleTreemapEntityGroupList.map((entityGroup) => {
      const { entityType, JSXElement, center } = entityGroup;
      const originalCenterX = center.x;
      const originalCenterY = center.y;

      const updated = updatedImpactTypeBubbleTreemapCenterList.find((c: any) => c.group === entityType);
      const updatedCenterX = updated?.x ?? originalCenterX;
      const updatedCenterY = updated?.y ?? originalCenterY;

      // 注意：transform 从右到左应用
      return (
        <g
          id={`optimized-bubble-treemap-entity-group-${entityType}`}
          key={`optimized-group-${entityType}`}
          transform={`translate(${updatedCenterX - originalCenterX}, ${updatedCenterY - originalCenterY})`}
        >
          <g
            transform={`
              translate(${originalCenterX}, ${originalCenterY})
              scale(${Scale ?? 1})
              translate(${-originalCenterX}, ${-originalCenterY})
            `}
          >
            {JSXElement}
          </g>
        </g>
      );
    });
    return list;
  }, [bubbleTreemapEntityGroupList, updatedImpactTypeBubbleTreemapCenterList, Scale, citationFlowType, highlghtedGrantFieldNode]);

  // 3) 变换后的 leaf 节点坐标与半径（与 SVG 相同的变换）
  const transformedLeafNodePositionList = useMemo(() => {
    const before = leafNodePosition_InitialCenter?.leafNodePositionList || [];
    const centersBefore = leafNodePosition_InitialCenter?.bubbleTreemapEntityTypeCenterXYList || [];

    if (!Scale || !updatedImpactTypeBubbleTreemapCenterList.length) return before;

    return before.map((leafNode) => {
      const entityType = leafNode.data.entityType;
      const originalCenter = centersBefore.find((c) => c.entityType === entityType)?.center;
      const updatedCenter = updatedImpactTypeBubbleTreemapCenterList.find((c: any) => c.group === entityType);

      if (!originalCenter || !updatedCenter) return leafNode;

      return {
        ...leafNode,
        x: (leafNode.x - originalCenter.x) * Scale + updatedCenter.x,
        y: (leafNode.y - originalCenter.y) * Scale + updatedCenter.y,
        r: leafNode.r * Scale,
      };
    });
  }, [
    Scale,
    leafNodePosition_InitialCenter?.leafNodePositionList,
    leafNodePosition_InitialCenter?.bubbleTreemapEntityTypeCenterXYList,
    updatedImpactTypeBubbleTreemapCenterList,
  ]);

  // 4) 变换后的每类中心
  const transformedBubbleTreemapEntityTypeCenterXYList = useMemo(() => {
    const before = leafNodePosition_InitialCenter?.bubbleTreemapEntityTypeCenterXYList || [];
    if (!updatedImpactTypeBubbleTreemapCenterList.length) return before;

    return before.map((c) => {
      const updated = updatedImpactTypeBubbleTreemapCenterList.find((u: any) => u.group === c.entityType);
      return updated ? { ...c, center: { x: updated.x, y: updated.y } } : c;
    });
  }, [leafNodePosition_InitialCenter?.bubbleTreemapEntityTypeCenterXYList, updatedImpactTypeBubbleTreemapCenterList]);

  // 5) 调试圆（稳定 key）
  const testCenterList = useMemo(() => {
    const nodes = entityTypeLayoutData?.nodes || [];
    return nodes.map((node: any, i: number) => (
      <circle
        key={`original-center-${node.id ?? `${node.group}-${i}`}`}
        cx={node.x}
        cy={node.y}
        r={20}
        fill="purple"
        fillOpacity={0.5}
      />
    ));
  }, [entityTypeLayoutData?.nodes]);

  const testUpdatedCenterList = useMemo(() => {
    return updatedImpactTypeBubbleTreemapCenterList.map((c: any, i: number) => (
      <circle
        key={`updated-center-${c.id ?? `${c.group}-${i}`}`}
        cx={c.x}
        cy={c.y}
        r={10}
        fill="green"
        fillOpacity={0.7}
      />
    ));
  }, [updatedImpactTypeBubbleTreemapCenterList]);

  const originalLeafNodeTestCircles = useMemo(() => {
    const before = leafNodePosition_InitialCenter?.leafNodePositionList || [];
    return before.map((leafNode, i) => (
      <circle
        key={`original-leaf-${leafNode.data.entityType}-${leafNode.data.name}-${i}`}
        cx={leafNode.x}
        cy={leafNode.y}
        r={Math.max(2, leafNode.r * 0.6)}
        fill="blue"
        fillOpacity={0.5}
        stroke="darkblue"
        strokeWidth={1}
      />
    ));
  }, [leafNodePosition_InitialCenter?.leafNodePositionList]);

  const transformedLeafNodeTestCircles = useMemo(() => {
    return transformedLeafNodePositionList.map((leafNode, i) => (
      <circle
        key={`transformed-leaf-${leafNode.data.entityType}-${leafNode.data.name}-${i}`}
        cx={leafNode.x}
        cy={leafNode.y}
        r={Math.max(3, leafNode.r * 0.8)}
        fill="red"
        fillOpacity={0.3}
        stroke="darkred"
        strokeWidth={1}
      />
    ));
  }, [transformedLeafNodePositionList]);




  // ============== 副作用区：写回 Redux（带去重） ==============
  const prevPayloadHashRef = useRef<string>('');
  useEffect(() => {
    if (!isOptimizingMainViewLayoutFinished || !Scale) return;

    const payload = {
      leafNodePositionList: transformedLeafNodePositionList,
      bubbleTreemapEntityTypeCenterXYList: transformedBubbleTreemapEntityTypeCenterXYList,
    };

    // console.log('\n\n\n========== OptimizedBubbleTreemap useEffect start ==========')
    // console.log('transformedLeafNodePositionList: ', transformedLeafNodePositionList)
    // console.log('transformedBubbleTreemapEntityTypeCenterXYList: ', transformedBubbleTreemapEntityTypeCenterXYList)
    // console.log('========== useEffect end ==========\n\n\n')

    const hash = JSON.stringify(payload);
    if (hash !== prevPayloadHashRef.current) {
      // data reducer
      // update node position
      updateLeafNodePositionList(payload);
      updateEntityFieldGraph_InputData(updatedImpactTypeBubbleTreemapCenterList)

      // update node size scale
      // updateLeafNodeSizeScale(updatedLeafNodeSizeScale, leafNodeSizeScaleType) // old version
      updateLeafNodeSizeScaleForHighlightedGrantField(updatedLeafNodeSizeScale, leafNodeSizeScaleType) // new version: seperate node size scale for (1) initialize/optimize field-level layout and (2) highlighted grant field, cause (2) always happen after (1)

      // ui reducer
      updateIsOptimizedBubbleTreemapFinished(true)
      // updateIsEntityFieldGraphFinished(true)
      setShowEntityFieldLevelGraph(true)
      setShowEntityTypeLevelGraph(true)

      prevPayloadHashRef.current = hash;
    }
  }, [
    isOptimizingMainViewLayoutFinished,
    Scale,
    transformedLeafNodePositionList,
    transformedBubbleTreemapEntityTypeCenterXYList,
    updatedImpactTypeBubbleTreemapCenterList,
    updateLeafNodePositionList,
  ]);

  // ============== 渲染早退：放在所有 Hook 之后，遵守 Hooks 规则 ==============
  if (!mainviewLayoutOptimizationParams || !isOptimizingMainViewLayoutFinished || !isInitializeBubbleTreemapFinished) {
    return null;
  }

  return (
    <g id="optimized-bubble-treemap-wrapper" className="fade-in-appear">
      {optimizedBubbleTreemapEntityTypeGroupElementList}
      {/* {optimizedBubbleTreemapEntityTypeGroupElementList_old} */}
      {/* 调试：紫=原中心，绿=新中心 */}
      {/* {testCenterList} */}
      {/* {testUpdatedCenterList} */}
      {/* 调试：蓝=原 leaf，红=变换后 leaf */}
      {/* {originalLeafNodeTestCircles} */}
      {/* {transformedLeafNodeTestCircles} */}
    </g>
  );
};

export default OptimizedBubbleTreemap;
